import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import styles from './LicensePlate.module.scss';
import InputWrapper from '../InputWrapper/InputWrapper';

export interface LicensePlateProps {
  onChange: (value: string) => void;
}

const LicensePlate: FC<LicensePlateProps> = ({ onChange }) => {
  const [licensePlateAlphabet, setLicensePlateAlphabet] = useState<string>('');
  const [licensePlateNumbers, setLicensePlateNumbers] = useState<string>('');
  const [alphaFocused, setAlphaFocused] = useState<boolean>(false);
  const [numFocused, setNumFocused] = useState<boolean>(false);
  const [touched, setTouched] = useState<boolean>(false);

  const focused = useMemo(() => alphaFocused || numFocused, [alphaFocused, numFocused]);

  const valid = useMemo(() => !!licensePlateAlphabet.length && !!licensePlateNumbers.length, [
    licensePlateAlphabet,
    licensePlateNumbers,
  ]);

  const alphaRef = useRef<HTMLInputElement>(null);
  const numRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const licensePlate = !!licensePlateAlphabet && !!licensePlateNumbers ? `${licensePlateAlphabet}-${licensePlateNumbers}` : '';
    onChange(licensePlate);
  }, [licensePlateAlphabet, licensePlateNumbers]);

  const handleLicensePlateAlphabetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-ZÅÄÖ]/g, '');
    setLicensePlateAlphabet(value);
    if (value.length === 3) {
      numRef.current?.focus();
    }
  };

  const handleLicensePlateNumbersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setLicensePlateNumbers(value);
  };

  return (
    <InputWrapper label="Rekisterinumero">
      <div className={styles.licensePlate + (touched && !valid && !focused ? ' ' + styles.licensePlateError : '')}>
        <div className={styles.licensePlateFin}>
          <div className={styles.euCircle}></div>
          <div className={styles.finText}>FIN</div>
        </div>

        <div className={styles.inputArea}>
          <input
            ref={alphaRef}
            placeholder="ABC"
            className={styles.input}
            onFocus={() => {
              setTouched(true);
              setAlphaFocused(true);
            }}
            onBlur={() => setAlphaFocused(false)}
            maxLength={3}
            type="text"
            onChange={handleLicensePlateAlphabetChange}
            value={licensePlateAlphabet}
          />
          <div className={styles.separator}>-</div>
          <input
            ref={numRef}
            placeholder="123"
            className={styles.input}
            onFocus={() => {
              setTouched(true);
              setNumFocused(true);
            }}
            onBlur={() => setNumFocused(false)}
            maxLength={3}
            type="text"
            onChange={handleLicensePlateNumbersChange}
            value={licensePlateNumbers}
          />
        </div>
      </div>
    </InputWrapper>
  );
};

export default LicensePlate;
